var map = {
	"./Appointment.svg": 8926,
	"./ApproveAppointment.svg": 8026,
	"./Doodle.svg": 186,
	"./FAQ.svg": 9356,
	"./Service.svg": 0,
	"./Staff.svg": 2990,
	"./crmImage.svg": 3250,
	"./empty.svg": 4664,
	"./emptyAppointments.svg": 661,
	"./emptyFaq.svg": 8895,
	"./emptyGallery.svg": 9813,
	"./emptyService.svg": 1494,
	"./freelancerlogo.svg": 4955,
	"./google_location.svg": 3673,
	"./homeIcon.svg": 372,
	"./loadingstate.svg": 9419,
	"./merchantslogo.svg": 1771,
	"./overviewClient.svg": 7576,
	"./sidebaricon.svg": 9828,
	"./staffAppointment.svg": 3652,
	"./staffEmail.svg": 9719,
	"./staffPhone.svg": 4099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;